module.exports = __webpack_public_path__ + "img/p1_bg.bacc5967.jpg";